import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../genderAction';
import fetchApi from "./fetchApi";

function fetchGenderAction() {
  return fetchApi('/v1/fc_api/gender_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchGenderAction;
